import styles from "./index.module.less";
import avatar from "./imgs/avatar.png";
import KefuIcon from "./imgs/kefu_icon.svg?react";
import Line from "./imgs/line.svg?react";
import { observer } from "mobx-react";
import { useStore } from "@/stores";
import { Flex, Space } from "antd";
import Agent from "../../Agent";
import { useState } from "react";
import classNames from "classnames";
import SVGIcon from "@/components/SVGIcon";
import { useEffect } from "react";

const MobileKefu = () => {
  const appStore = useStore("app");
  const [open, setOpen] = useState(false);
  const [showMenus, setShowMenus] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  useEffect(() => {
    if (showMenus) {
      window.gsap.set(`.${styles.menus}`, {
        transform: "translateY(120%)",
      });
      window.gsap.to(`.${styles.menus}`, {
        transform: "translateY(0)",
        duration: 0.3,
      });
    } else {
      window.gsap.to(`.${styles.menus}`, {
        transform: "translateY(120%)",
        duration: 0.3,
      });
    }
  }, [showMenus]);
  return (
    <div className={styles.kefu}>
      <div
        className={styles.kefuInner}
        onClick={() => setShowMenus(!showMenus)}
      >
        <img src={avatar} alt="客服头像" />
      </div>
        {/* {showMenus && ( */}
          <Flex
            vertical
            gap={'.12rem'}
            className={styles.menus}
          >
            <div
              className={styles.agent}
              onClick={() => {
                setOpen(true)
                setShowMenus(false);
              }}
            >
              <img src={avatar} alt="客服头像" />

              <span>在线咨询</span>
            </div>
            <div
              className={styles.contact}
              onClick={() => {
                appStore.openContactModal();
              }}
            >
              联系我们
            </div>
            <div
              className={styles.cancel}
              onClick={() => {
                setShowMenus(false);
              }}
            >
              取消
            </div>
          </Flex>
        {/* )} */}
      <Agent
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </div>
  );
};
export default observer(MobileKefu);
